import React, { useMemo } from 'react';
import { Battle } from '$store/models';
import { useTranslator, useUserInfo } from '$hooks';
import { format } from '$utils';
import { ListItem } from '$uikit';

export const BattleItems: React.FC<{ battle: Battle; routeName: string }> = ({
  battle,
  routeName,
}) => {
  const t = useTranslator();
  const one = useUserInfo(battle.oneUserId);
  const two = useUserInfo(battle.twoUserId);

  const description = useMemo(() => {
    const now = Date.now() / 1000;
    if (now > battle.endAt) {
      return t('battles_finished');
    } else {
      return t('battles_in_progress', {
        date: format(new Date(battle.endAt * 1000), 'd MMM HH:mm'),
      });
    }
  }, [battle.endAt, t]);

  return (
    <ListItem
      chevron
      description={description}
      routeName={routeName}
      routeParams={{ id: battle.id }}
    >
      {one.firstName} {one.lastName.substring(0, 1)} vs {two.firstName}{' '}
      {two.lastName.substring(0, 1)}
    </ListItem>
  );
};
